<template>
  <a-card :bordered="false">
    <a-spin :spinning="loading">
      <a-form :form="form" >
        <a-row>
          <a-col :span="24">
            <a-form-item label="业务号" :label-col="buttonItemLayout.labelCol" :wrapper-col="buttonItemLayout.wrapperCol">
              <a-input disabled v-decorator="['business_no', {rules: [{required: true, message: '必填项，请填写信息'}, {max:32, message: '输入超出长度限制'}]}]" placeholder="请输入"/>
            </a-form-item>
          </a-col>
          <a-col :span="12">
            <a-form-item label="采销全流程" :label-col="formItemLayout.labelCol" :wrapper-col="formItemLayout.wrapperCol">
              <a-input disabled v-model="selectedProject"/>
            </a-form-item>
          </a-col>
          <a-col :span="12" v-if="data !== undefined">
            <a-form-item :label="contractLabel" :label-col="formItemLayout.labelCol" :wrapper-col="formItemLayout.wrapperCol">
              <a-input disabled v-model="selectedSellContract"/>
            </a-form-item>
          </a-col>
          <a-col :span="12">
            <a-form-item label="付款主体" :label-col="formItemLayout.labelCol" :wrapper-col="formItemLayout.wrapperCol">
              <a-select
                :filter-option="false"
                :not-found-content="paymentCompanyFetching ? undefined : null"
                show-search
                allow-clear
                v-decorator="[
                  'payment_company_id',
                  {
                    rules: [
                      { required: true, message: '必填项，请填写信息' },
                    ],
                  },
                ]"
                placeholder="请输入公司名称"
                :default-active-first-option="false"
                @search="this.corporationSearch"
              >
                <a-spin v-if="paymentCompanyFetching" slot="notFoundContent" size="small" />
                <a-select-option v-for="d in paymentCompanyList" :key="d.id" :value="d.id">
                  {{ d.name }}
                </a-select-option>
              </a-select>
            </a-form-item>
          </a-col>
          <a-col :span="12">
            <a-form-item label="付款事由" :label-col="formItemLayout.labelCol" :wrapper-col="formItemLayout.wrapperCol">
              <a-select
                allow-clear
                v-decorator="[
                  'payment_reason',
                  {
                    rules: [
                      { required: true, message: '请选择' },
                    ],
                  },
                ]"
                placeholder="请选择"
                option-filter-prop="children"
                :filter-option="filterOption"
              >
                <a-select-option :key="key" :value="key" v-for="(val, key) in paymentApplicationReason">{{ val }}</a-select-option>
              </a-select>
            </a-form-item>
          </a-col>
          <a-col :span="12">
            <a-form-item label="付款金额" :label-col="formItemLayout.labelCol" :wrapper-col="formItemLayout.wrapperCol">
              <a-input-number style="width: 50%" :precision="4" v-decorator="['payment_amount', {initialValue: 0, rules: [{required: true, message: '必填项，请填写信息'}]}]" placeholder="金额"/>
              <a-select
                style="width: 50%"
                allow-clear
                v-decorator="[
                  'payment_amount_currency',
                  {
                    rules: [
                      { required: true, message: '请选择' }
                    ],
                  },
                ]"
                placeholder="选择币种"
                show-search
                option-filter-prop="children"
                :filter-option="filterOption"
              >
                <a-select-option :key="key" :value="key" v-for="(val, key) in this.$Dictionaries.currency">{{ val }}</a-select-option>
              </a-select>
            </a-form-item>
          </a-col>
          <a-col :span="12">
            <a-form-item label="付款事由说明" :label-col="formItemLayout.labelCol" :wrapper-col="formItemLayout.wrapperCol">
              <a-input v-decorator="['payment_reason_desc', {rules: [{required: false, message: '必填项，请填写信息'}, {max:128, message: '输入超出长度限制'}]}]" placeholder="请输入"/>
            </a-form-item>
          </a-col>
          <a-col :span="24">
            <a-divider orientation="left">
              收款账户信息
            </a-divider>
          </a-col>
          <a-col :span="12">
            <a-form-item label="收款公司" :label-col="formItemLayout.labelCol" :wrapper-col="formItemLayout.wrapperCol">
              <a-select
                :filter-option="false"
                :not-found-content="payeeCorporationFetching ? undefined : null"
                show-search
                allow-clear
                v-decorator="[
                  'payee_company_id',
                  {
                    rules: [
                      { required: true, message: '必填项，请填写信息' },
                    ],
                  },
                ]"
                placeholder="请输入公司名称"
                :default-active-first-option="false"
                @search="this.payeeCorporationSearch"
              >
                <a-spin v-if="payeeCorporationFetching" slot="notFoundContent" size="small" />
                <a-select-option v-for="d in payeeCompanyList" :key="d.id" :value="d.id">
                  {{ d.name }}
                </a-select-option>
              </a-select>
            </a-form-item>
          </a-col>
          <a-col :span="12">
            <a-form-item label="银行名称" :label-col="formItemLayout.labelCol" :wrapper-col="formItemLayout.wrapperCol">
              <a-input v-decorator="['bank_name', {rules: [{required: true, message: '必填项，请填写信息'}, {max:128, message: '输入超出长度限制'}]}]" placeholder="请输入"/>
            </a-form-item>
          </a-col>
          <a-col :span="12">
            <a-form-item label="银行账号" :label-col="formItemLayout.labelCol" :wrapper-col="formItemLayout.wrapperCol">
              <a-input v-decorator="['bank_account', {rules: [{required: true, message: '必填项，请填写信息'}, {max:32, message: '输入超出长度限制'}]}]" placeholder="请输入"/>
            </a-form-item>
          </a-col>
          <a-col :span="12">
            <a-form-item label="银行地址" :label-col="formItemLayout.labelCol" :wrapper-col="formItemLayout.wrapperCol">
              <a-input v-decorator="['bank_address', {rules: [{required: false, message: '必填项，请填写信息'}, {max:256, message: '输入超出长度限制'}]}]" placeholder="请输入"/>
            </a-form-item>
          </a-col>
          <a-col :span="12">
            <a-form-item label="SWIFT CODE" :label-col="formItemLayout.labelCol" :wrapper-col="formItemLayout.wrapperCol">
              <a-input v-decorator="['swift_code', {rules: [{required: false, message: '必填项，请填写信息'}, {max:32, message: '输入超出长度限制'}]}]" placeholder="请输入"/>
            </a-form-item>
          </a-col>
          <a-col :span="12">
            <a-form-item label="大额行号" :label-col="formItemLayout.labelCol" :wrapper-col="formItemLayout.wrapperCol">
              <a-input v-decorator="['cnaps_code', {rules: [{required: false, message: '必填项，请填写信息'}, {max:32, message: '输入超出长度限制'}]}]" placeholder="请输入"/>
            </a-form-item>
          </a-col>
          <a-col :span="24">
            <a-divider orientation="left">
              审批信息
            </a-divider>
          </a-col>
          <a-col :span="12">
            <a-form-item label="开启审批" :label-col="formItemLayout.labelCol" :wrapper-col="formItemLayout.wrapperCol">
              <a-switch v-decorator="['is_approval_needed', { initialValue: false, valuePropName: 'checked' }]" />
            </a-form-item>
          </a-col>
        </a-row>
        <a-form-item v-bind="buttonCol">
          <a-row>
            <a-col span="6" :offset="6">
              <a-button type="primary" html-type="submit" @click="handleSubmit" :loading="submitting">提交</a-button>
            </a-col>
            <a-col span="10">
              <a-button @click="handleGoBack">返回</a-button>
            </a-col>
            <a-col span="8"></a-col>
          </a-row>
        </a-form-item>
      </a-form>
    </a-spin>
  </a-card>
</template>

<script>
import moment from 'moment'
import pick from 'lodash.pick'
import debounce from 'lodash/debounce'
import { bank_list } from '@/api/trade_bank'
import { payment_application_list, payment_application_update } from '@/api/trade_payment'
import { corporation_list } from '@/api/trade_corporation'
import { client_list } from '@/api/trade_client'
const fields = ['id', 'business_no', 'payment_company_id', 'payment_reason', 'payment_amount', 'payment_amount_currency', 'payment_reason_desc', 'payee_company_id',
  'bank_name', 'bank_account', 'bank_address', 'swift_code', 'cnaps_code', 'is_approval_needed']
export default {
  name: 'TableEdit',
  props: {
    record: {
      type: [Object, String],
      default: ''
    }
  },
  data () {
    this.corporationSearch = debounce(this.handleCorporationSearch, 800)
    this.payeeCorporationSearch = debounce(this.handlePayeeCorporationSearch, 800)
    this.bankSearch = debounce(this.handleBankSearch, 800)
    this.advisingBankSearch = debounce(this.handleAdvisingBankSearch, 800)
    return {
      formLayout: 'horizontal',
      form: this.$form.createForm(this),
      id: 0,
      paymentCompanyFetching: false,
      payeeCorporationFetching: false,
      paymentCompanyList: [],
      payeeCompanyList: [],
      paymentApplicationReasonList: this.$Dictionaries.trade_payment_application_reasons,
      paymentApplicationReasonList2: this.$Dictionaries.trade_payment_application_reasons2,
      data: undefined,
      loading: false,
      submitting: false,
      bankFetching: false,
      advisingBankFetching: false,
      bankList: [],
      advisingBankList: [],
      issuingBankId: undefined,
      contractType: undefined,
      accordingContract: true,
      selectedLetterCreditType: 0,
      buttonCol: {
        wrapperCol: {
          xs: { span: 24 },
          sm: { span: 12, offset: 5 }
        }
      }
    }
  },
  mounted () {
    this.loadApplicationData()
  },
  computed: {
    formItemLayout () {
      const { formLayout } = this
      return formLayout === 'horizontal'
        ? {
          labelCol: { span: 6 },
          wrapperCol: { span: 18 }
        } : {}
    },
    buttonItemLayout () {
      const { formLayout } = this
      return formLayout === 'horizontal'
        ? {
          labelCol: { span: 3 },
          wrapperCol: { span: 21 }
        } : {}
    },
    selectedSellContract () {
      if (this.data === undefined) {
        return ''
      }
      return this.data.contract_number
    },
    contractLabel () {
      if (this.data === undefined) {
        return ''
      }
      return this.data.contract_type.startsWith('100') ? '购销合同' : '普通合同'
    },
    selectedProject () {
      if (this.data === undefined) {
        return ''
      }
      return this.data.project
    },
    paymentApplicationReason () {
      if (this.contractType === 100) {
        return this.paymentApplicationReasonList
      } else if (this.contractType === 200) {
        return this.paymentApplicationReasonList2
      }
      return []
    }
  },
  methods: {
    moment,
    handleGoBack () {
      // this.$emit('onGoBack')
      this.$router.go(-1)
    },
    loadApplicationData () {
      this.loading = true
      payment_application_list({ id: this.$route.params.id })
        .then(res => {
          console.log(res.data, '我是数据列表@')
          const list = res.data.entries
          if (list && list.length > 0) {
            this.data = list[0]
            this.id = this.data.id
            this.selectedLetterCreditType = '' + this.data.letter_credit_type
            this.accordingContract = this.data.is_according_contract
            this.contractType = Number(this.data.contract_type.split(',')[0])
            this.loadEditInfo(this.data)
          }
        }).finally(() => {
        this.loading = false
      })
    },
    handleSubmit () {
      const { form: { validateFields } } = this
      validateFields((err, values) => {
        console.log('我要提交接口', values)
        if (!err) {
          this.loading = true
          this.submitting = true
          payment_application_update(values, this.id)
            .then((res) => {
              this.handleGoBack()
              console.log(res, '修改成功')
            }).finally(() => {
              this.loading = false
              this.submitting = false
          })
        }
      })
    },
    filterOption (input, option) {
      return (
        option.componentOptions.children[0].text.toLowerCase().indexOf(input.toLowerCase()) >= 0
      )
    },
    loadEditInfo (data) {
      const { form } = this
      console.log(`将加载 ${this} 信息到表单`)
      new Promise((resolve) => {
        setTimeout(resolve, 0)
      }).then(() => {
        const formData = pick(data, fields)
        formData.payment_reason = '' + formData.payment_reason
        formData.letter_credit_type = '' + formData.letter_credit_type
        formData.margin_source = '' + formData.margin_source
        console.log('formData', formData)
        this.id = formData.id
        formData.type = String(formData.type)
        form.setFieldsValue(formData)
      }).finally(() => {
        if (data.payment_company_id) {
          this.corporationLoadList({ id: data.payment_company_id }, 1)
        }
        if (data.payee_company_id) {
          this.clientLoadList({ id: data.payee_company_id })
        }
        if (data.issuing_bank_id) {
          this.backLoadList({ id: data.issuing_bank_id }, 1)
        }
        if (data.advising_bank_id) {
          this.backLoadList({ id: data.advising_bank_id }, 2)
        }
      })
    },
    handleCorporationSearch (value) {
      this.corporationLoadList({ name: value }, 1)
    },
    handlePayeeCorporationSearch (value) {
      this.clientLoadList({ name: value })
    },
    clientLoadList (parameter) {
      this.payeeCorporationFetching = true
      client_list(parameter).then((res) => {
        this.payeeCompanyList = res.data.entries || []
      }).finally(() => {
        this.payeeCorporationFetching = false
      })
    },
     corporationLoadList (parameter, index) {
      if (index === 1) {
        this.paymentCompanyFetching = true
      } else {
        this.payeeCorporationFetching = true
      }
       corporation_list(parameter).then((res) => {
        if (index === 1) {
          this.paymentCompanyList = res.data.entries || []
        } else {
          this.payeeCompanyList = res.data.entries || []
        }
      }).finally(() => {
        if (index === 1) {
          this.paymentCompanyFetching = false
        } else {
          this.payeeCorporationFetching = false
        }
      })
    },
    handleBankSearch (value) {
      this.backLoadList({ name: value }, 1)
    },
    handleAdvisingBankSearch (value) {
      this.backLoadList({ name: value }, 2)
    },
    backLoadList (parameter, index) {
      if (index === 1) {
        this.bankFetching = true
      } else {
        this.advisingBankFetching = true
      }
      bank_list(parameter).then((res) => {
        if (index === 1) {
          this.bankList = res.data.entries || []
        } else {
          this.advisingBankList = res.data.entries || []
        }
      }).finally(() => {
        if (index === 1) {
          this.bankFetching = false
        } else {
          this.advisingBankFetching = false
        }
      })
    },
    handleAccordingContractChange (value) {
      this.accordingContract = value
    },
    handleLetterCreditTypeChange (value) {
      this.selectedLetterCreditType = value
    }
  }
}
</script>
